const styles = (theme) => ({
  supportingLinksContainer: {
    marginBottom: theme.spacing(2),
  },
  supportingLinksTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  linkRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  linkInput: {
    flexGrow: 1,
    marginRight: theme.spacing(2),
    padding: '14px 16px',
    fontSize: '16px',
    borderRadius: 10,
    border: `1px solid ${theme.palette.primary.main}`,
    outline: 'none',
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
  },
  removeButton: {
    color: 'white',
    backgroundColor: theme.palette.accentRed.main,
    padding: 0,
    width: 24,
    height: 24,
    minWidth: 24,
    '&:hover': {
      backgroundColor: theme.palette.accentRed.dark,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },
  removeButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  addButton: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    border: 'none',
    borderRadius: 10,
    padding: theme.spacing(1.5),
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white', 
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(1),
    },
    '& .MuiButton-label': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  addButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  addIcon: {
    color: theme.palette.primary.main,
    transition: 'color 0.3s ease',
  },
});

export default styles;
